module.exports = __webpack_public_path__ + "static/media/chevron-back.b8e129ab.svg";